module.exports = __webpack_public_path__ + "bf8dad.png";